import {
    GET_CATEGORIES_BENEFITS,
    GET_CATEGORY_TYPE,
    GET_SUBCATEGORIES,
    GET_STATE_LOADING,
    GET_CATEGORIES_ID,
    GET_CATEGORIES,
    GET_MODO,
} from "@/views/categories_board/store/types/types.js";

const getters = {
    [GET_CATEGORIES_BENEFITS]: state => state.categories_board_benefits,
    [GET_SUBCATEGORIES]: state => state.subcategories_board,
    [GET_CATEGORY_TYPE]: state => state.categories_type,
    [GET_CATEGORIES]: state => state.categories_board,
    [GET_CATEGORIES_ID]: state => state.category,
    [GET_STATE_LOADING]: state => state.loading,  
    [GET_MODO]: state => state.modos,
};

export default getters;